export default __webpack_public_path__ + "images/onboarding-slide-3.0c1a76b7e1b7f4d8f512f21ac027c291.svg";